<template>
  <div class="index_up_vue common_margin_top_2">
    <el-row class="important_dept_parent">
      <el-col style="width: 25%">
        <div class="important_dept xlzx" @click="tokeyDepartMents('/keyDepartments/context',departmentList[0].id)">
          <div class="img_div"></div>
          <div class="text_div">{{ departmentList[0].name }}</div>
        </div>
      </el-col>
      <el-col style="width: 25%">
        <div class="important_dept etqsn" @click="tokeyDepartMents('/keyDepartments/context',departmentList[1].id)">
          <div class="img_div"></div>
          <div class="text_div">{{ departmentList[1].name }}</div>
        </div>
      </el-col>
      <el-col style="width: 25%">
        <div class="important_dept jyjj" @click="tokeyDepartMents('/keyDepartments/context',departmentList[2].id)">
          <div class="img_div"></div>
          <div class="text_div">{{ departmentList[2].name }}</div>
        </div>
      </el-col>
      <el-col style="width: 25%">
        <div class="important_dept lncj" @click="tokeyDepartMents('/keyDepartments/context',departmentList[3].id)">
          <div class="img_div"></div>
          <div class="text_div">{{ departmentList[3].name }}</div>
        </div>
      </el-col>
<!--      <el-col style="width: 20%">
        <div class="important_dept kfzl" @click="tokeyDepartMents('/keyDepartments/context',departmentList[4].id)">
          <div class="img_div"></div>
          <div class="text_div">{{ departmentList[4].name }}</div>
        </div>
      </el-col>-->
    </el-row>
    <el-row style="min-height: 415px">
      <el-col :span="16">
        <el-row style="padding-top: 2px">
          <div class="common_title" style="width: 97.5%">
            <img src="~@/assets/img/index/xwdt.png" height="22" width="22" style="position: relative;top: 3px"/>
            <span class="active_span">新闻动态</span>
            <router-link class="a_cla" :to="{path:'/newsInformation/hospitalNews'}">更多>></router-link>
            <hr>
          </div>
          <el-row>
            <el-col :span="11" style="padding-top: 20px;padding-left: 1px;">
              <el-carousel height="316px" width="353px" indicator-position="none">
                <template v-for="(item,index) in imagesList" v-if="index<5">
                  <el-carousel-item :key="index">
                    <router-link v-if="item.url != null" tag="a" :to="{path:'/newsInformation/newsDetail',query: {id: item.url}}">
                      <img :src="'https://www.lcjfzx.cn/'+'/imgUrl/'+item.photo.split('/')[3]" height="316px"
                           width="353px">
                      <div class="img_bot">{{ item.name }}</div>
                    </router-link>
                    <template v-else>
                      <img :src="'https://www.lcjfzx.cn/'+'/imgUrl/'+item.photo.split('/')[3]" height="316px"
                           width="353px">
                      <div class="img_bot">{{ item.name }}</div>
                    </template>
                  </el-carousel-item>
                </template>
              </el-carousel>
            </el-col>
            <el-col :span="13">
              <div class="common_padding_rigth_2">
                <div class="common_news_ul" v-for="(item,index) in newsList" v-if="index<=4" :key="index">
                  <div style="height: 30px;line-height: 25px">
                    <router-link class="new_txt" tag="a" :to="{path:'/newsInformation/newsDetail',query: {id: item.id}}">
                      <span style="font-size: 20px;position: relative;top: 2px">·</span>
                      <img v-if="index===0" src="~@/assets/img/index/new_message.gif" height="14" width="30" style="position: relative;top: 1px"/>
                      <el-tooltip :disabled="item.title.length<17" class="item" effect="dark" :content="item.title" placement="top-start">
                        <span :class="{'first_title':index===0}">{{ item.title }}</span>
                      </el-tooltip>
                    </router-link>
                    <!--                    <span class="new_time">{{ item.createdDate != null ? $moment(item.createdDate).format('YYYY-MM-DD') : '' }}</span>-->
                  </div>
                  <div style="font-size: 12px;padding-left: 12px;color: #999;line-height:16px;text-align: left" v-html="item.content"></div>
                </div>
              </div>
            </el-col>
          </el-row>
        </el-row>
      </el-col>
      <el-col :span="8">
        <div class="common_title">
          <img src="~@/assets/img/index/tzgg.png" height="20" width="18" style="position: relative;top: 2px"/>
          <span class="active_span">通知公告</span>
          <router-link class="a_cla" :to="{path:'/announcementDynamics/noticeAnnouncement'}">更多>></router-link>
          <hr style="top: 14px">
        </div>
        <div class="common_padding_rigth_2">
          <div class="common_news_ul" v-for="(item,index) in noticeList" v-if="index<=4" :key="index">
            <div style="height: 30px;line-height: 25px">
              <router-link class="new_txt" tag="a" :to="{path:'/announcementDynamics/noticeDetail',query: {id: item.id}}">
                <span style="font-size: 20px;position: relative;top: 2px">·</span>
                <img v-if="index===0" src="~@/assets/img/index/new_message.gif" height="14" width="30" style="position: relative;top: 1px"/>
                <el-tooltip :disabled="item.title.length<17" class="item" effect="dark" :content="item.title" placement="top-start">
                  <span :class="{'first_title':index===0}">{{ item.title }}</span>
                </el-tooltip>
              </router-link>
              <!--              <span class="new_time">{{ item.createdDate != null ? $moment(item.createdDate).format('YYYY-MM-DD') : '' }}</span>-->
            </div>
            <div style="font-size: 12px;padding-left: 12px;color: #999;line-height:16px;text-align: left" v-html="item.content"></div>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-row :gutter="25" style="margin-top: 35px;min-height: 517px">
      <el-col :span="8">
        <div class="common_title">
          <img src="~@/assets/img/index/xwdt.png" height="22" width="22" style="position: relative;top: 3px"/>
          <span class="active_span">健康科普</span>
          <router-link class="a_cla" :to="{path:'/newsInformation/jkkpList'}">更多>></router-link>
          <hr>
        </div>
        <div class="common_padding_rigth_2">
          <img src="~@/assets/img/index/health.webp" height="190px" width="100%" style="margin-top: 10px"/>
          <div v-for="(item,index) in healthList" v-if="index<=4" :key="index">
            <div class="new_title_cla">
              <router-link class="new_txt_new" tag="a" :to="{path:'/newsInformation/newsDetail',query: {id: item.id}}">
                <img src="~@/assets/img/index/plus.png" height="10" width="10" style="position: relative;margin-right: 5px"/>
                <el-tooltip :disabled="item.title.length<17" class="item" effect="dark" :content="item.title" placement="top-start">
                  <span>{{ item.title }}</span>
                </el-tooltip>
              </router-link>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :span="8">
        <div class="common_title">
          <img src="~@/assets/img/index/tzgg.png" height="22" width="22" style="position: relative;top: 3px"/>
          <span class="active_span">规章文件</span>
          <router-link class="a_cla" :to="{path:'/gzwj/gzwjIndex'}">更多>></router-link>
          <hr>
        </div>
        <div class="common_padding_rigth_2">
          <img src="~@/assets/img/index/fltw.webp" height="190px" width="100%" style="margin-top: 10px"/>
          <div v-for="(item,index) in fltwList" v-if="index<=4" :key="index">
            <div class="new_title_cla">
              <router-link class="new_txt_new" tag="a" :to="{path:'/other/newsDetail',query: {id: item.id}}">
                <img src="~@/assets/img/index/plus.png" height="10" width="10" style="position: relative;margin-right: 5px"/>
                <el-tooltip :disabled="item.title.length<17" class="item" effect="dark" :content="item.title" placement="top-start">
                  <span>{{ item.title }}</span>
                </el-tooltip>
              </router-link>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :span="8">
        <div class="common_title">
          <img src="~@/assets/img/index/welfare.png" height="22" width="22" style="position: relative;top: 3px"/>
          <span class="active_span">公益活动</span>
          <router-link class="a_cla" :to="{path:'/newsInformation/gyhdList'}">更多>></router-link>
          <hr>
        </div>
        <div class="common_padding_rigth_2">
          <img src="~@/assets/img/index/gyhd.webp" height="190px" width="100%" style="margin-top: 10px"/>
          <div v-for="(item,index) in gyhdList" v-if="index<=4" :key="index">
            <div class="new_title_cla">
              <router-link class="new_txt_new" tag="a" :to="{path:'/newsInformation/newsDetail',query: {id: item.id}}">
                <img src="~@/assets/img/index/plus.png" height="10" width="10" style="position: relative;margin-right: 5px"/>
                <el-tooltip :disabled="item.title.length<17" class="item" effect="dark" :content="item.title" placement="top-start">
                  <span>{{ item.title }}</span>
                </el-tooltip>
              </router-link>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import Qs from 'qs';
import Swiper from "swiper";
import {mapGetters} from "vuex";

export default {
  name: "index-up-vue",
  data() {
    return {
      pageable: {
        size: 9,
        page: 0,
        type: '11',
        sort: 'orderField,desc',
      },
      newsList: [],
      newsPicList: [],
      noticeList: [],
      imagesList: [],
      departmentList: [],
      healthList: [],
      fltwList: [],
      gyhdList: []
    }
  },
  computed: {
    baseApi() {
      //由于vuex的状态存储是响应式的，所以从store实例中读取状态的最简单方法就是使用计算属性来返回某个状态：
      return this.$store.getters.baseApi;
    },
  },
  created() {
    this.getDataList();
  },
  methods: {
    tokeyDepartMents: function (val, id) {
      //设置激活按钮样式
      this.$store.dispatch('departmentIdAction', id)
      this.$router.push({
        path: val,
        query: {id: id}
      })
    },
    getDataList: function () {
      this.service.fetch(
        '/departments/getKeyDepartments',
      ).then(res => {
        this.departmentList = res;
      })
    },
    getNewsList: function () {
      this.service.fetch(
        '/richText/getTopThree'
      ).then(res => {
        this.newsList = res;
        for (let i in this.newsList) {
          const parser = new DOMParser();
          const doc = parser.parseFromString(this.newsList[i].content, 'text/html');
          const cleanString = doc.body.textContent || "";
          if (this.newsList[i].content.length > 50) {
            this.newsList[i].content = cleanString.substring(0, 50) + '...';
          }
        }
      })
    },
    getNoticeList: function () {
      let data = Qs.stringify(this.pageable);
      this.service.post(
        '/announcements/findByTypeStatus', data
      ).then(res => {
        this.noticeList = res.data;
        for (let i in this.noticeList) {
          const parser = new DOMParser();
          const doc = parser.parseFromString(this.noticeList[i].content, 'text/html');
          const cleanString = doc.body.textContent || "";
          if (this.noticeList[i].content.length > 50) {
            this.noticeList[i].content = cleanString.substring(0, 50) + '...';
          }
        }
        // this.addAnimateNew();
      })
    },
    getHealthList: function () {
      let pageable = {
        size: 5,
        page: 0,
        type: '18',
        sort: 'orderField,desc',
      }
      let data = Qs.stringify(pageable);
      this.service.post(
        '/richText/findByTypeStatus', data
      ).then(res => {
        this.healthList = res.data;
        for (let i in this.healthList) {
          const parser = new DOMParser();
          const doc = parser.parseFromString(this.healthList[i].content, 'text/html');
          const cleanString = doc.body.textContent || "";
          if (this.healthList[i].content.length > 50) {
            this.healthList[i].content = cleanString.substring(0, 50) + '...';
          }
        }
      })
    },
    getFltwList: function () {
      let pageable = {
        size: 5,
        page: 0,
        type: '15',
        sort: 'orderField,desc',
      }
      let data = Qs.stringify(pageable);
      this.service.post(
        '/richText/findByTypeStatus', data
      ).then(res => {
        this.fltwList = res.data;
        for (let i in this.fltwList) {
          const parser = new DOMParser();
          const doc = parser.parseFromString(this.fltwList[i].content, 'text/html');
          const cleanString = doc.body.textContent || "";
          if (this.fltwList[i].content.length > 50) {
            this.fltwList[i].content = cleanString.substring(0, 50) + '...';
          }
        }
      })
    },
    getGyhdList: function () {
      let pageable = {
        size: 5,
        page: 0,
        type: '19',
        sort: 'orderField,desc',
      }
      let data = Qs.stringify(pageable);
      this.service.post(
        '/richText/findByTypeStatus', data
      ).then(res => {
        this.gyhdList = res.data;
        for (let i in this.gyhdList) {
          const parser = new DOMParser();
          const doc = parser.parseFromString(this.gyhdList[i].content, 'text/html');
          const cleanString = doc.body.textContent || "";
          if (this.gyhdList[i].content.length > 50) {
            this.gyhdList[i].content = cleanString.substring(0, 50) + '...';
          }
        }
      })
    },
    getTopThree: function () {
      this.service.fetch(
        '/richText/getTopThree'
      ).then(res => {
        //获取五张
        if (res.length >= 6) {
          for (let i = 0; i < res.length - 1; i++) {
            this.newsPicList.push(res[i])
          }
        } else {
          this.newsPicList = res;
        }

      })
    },
    getImageTop5() {
      this.service.fetch(
        '/images/getImageTop5'
      ).then(res => {
        this.imagesList = res;
        //获取五张

      })
    },
    toNewsDetail(id) {
      this.$router.push({
        path: '/newsInformation/newsDetail',
        query: {
          id: id
        }
      })
    },
    toAnyPage: function (path) {
      this.$router.push({path: path});
    },
    addAnimateNew: function () {
      let that = this;
      setTimeout(function () {
        if (that.noticeList.length > 5) {
          new Swiper("#swiper3", {
            initialSlide: 0,
            freeMode: false,
            loop: true,
            slidesPerView: 'auto',
            direction: 'vertical',
            autoplay: {
              disableOnInteraction: false,
              delay: 1500,
              stopOnLastSlide: false,
            },
          });
        }
      }, 2000)

    },
  },
  mounted() {
    this.getNewsList();
    // this.getTopThree();
    this.getNoticeList();
    this.getImageTop5();
    this.getHealthList();
    this.getFltwList();
    this.getGyhdList();
  }
}
</script>

<style scoped lang="scss">
@import "~@/assets/style/element-ui.scss";

.important_dept_parent {
  margin-top: 20px;
  margin-bottom: 20px;

  .important_dept {
    width: 95%;
    height: 99px;
    margin: 0 auto;
    cursor: pointer;
  }

  .important_dept:hover {
    .text_div {
      font-size: 25px;
    }
  }

  .img_div {
    width: 36px;
    height: 36px;
    margin: 31px 0 31px 36px;
    float: left;
    -webkit-transition: all 0.6s;
    transition: all 0.6s;
  }


  .text_div {
    font-size: 22px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #fff;
    float: left;
    margin-top: 30px;
    -webkit-transition: all 0.3s;
    transition: all 0.3s;
    width: 60%;
    line-height: 37px;
    height: 37px;
    text-align: center;
  }

  .xlzx {
    background: linear-gradient(0deg, rgba(103, 195, 158, 1), rgba(165, 244, 209, 1));

    .img_div {
      background: url("~@/assets/img/index/xlzx.png");
      background-size: 100% 100%;
    }
  }

  .etqsn {
    background: linear-gradient(0deg, rgba(246, 125, 73, 1), rgba(234, 161, 106, 1));

    .img_div {
      background: url("~@/assets/img/index/jieyan.png");
      background-size: 100% 100%;
    }
  }

  .jyjj {
    background: linear-gradient(0deg, rgba(8, 101, 213, 1), rgba(5, 157, 221, 1));

    .img_div {
      background: url("~@/assets/img/index/zhongdianqingshaonian.png");
      background-size: 100% 100%;
    }
  }

  .lncj {
    background: linear-gradient(0deg, rgba(220, 190, 130, 1), rgba(254, 228, 174, 1));

    .img_div {
      background: url("~@/assets/img/index/laoniankangfu.png");
      background-size: 100% 100%;
    }
  }

  .kfzl {
    background: linear-gradient(0deg, rgba(195, 2, 34, 1), rgba(243, 91, 117, 1));

    .img_div {
      background: url("~@/assets/img/index/kangfuke.png");
      background-size: 100% 100%;
    }
  }
}

.index_up_vue {
  overflow: hidden;

  .title_two {
    width: 104px;
    height: 24px;
    font-size: 24px;
    font-family: PingFang SC;
    font-weight: bold;
    color: rgba(31, 80, 173, 1);
    line-height: 17px;
  }
}

.index_up_vue > > .title_line_two {
  margin-top: 10px;
  width: 128px;
  height: 6px;
  background: rgba(31, 80, 173, 1);
  border-radius: 1px;
}

a {
  cursor: pointer;
}

.a_cla {
  color: #3c9bf1;
  text-decoration: none;
}

.a_cla:hover {
  color: #034186;
}

.new_txt {
  display: block;
  float: left;
  width: 310px;
  color: #034cc6;
  /*padding-top: 5px;*/
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  text-decoration: none;
}

.new_txt_new {
  display: block;
  float: left;
  width: 100%;
  color: #777777;
  font-size: 14px;
  /*padding-top: 5px;*/
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  text-decoration: none;
}

.new_txt:hover, .new_txt_new:hover {
  text-decoration: underline;
  color: #4ab344;
}

.new_time {
  float: right;
  color: #B3B1B1;
  /*padding-top: 5px;*/
  font-size: 13px !important;
}

.swiper-wrapper {
  display: block !important;
}

.img_bot {
  position: absolute;
  bottom: 0;
  background: #0000007a;
  width: 353px;
  height: 40px;
  color: #ffffff;
  line-height: 40px;
  text-align: center;
}

.first_title {
  color: #034cc6;
}

.new_title_cla {
  height: 50px;
  line-height: 50px;
  border-bottom: 1px dashed #ededed
}
</style>



// WEBPACK FOOTER //
// src/pages/mainView/index/components/indexUpVue.vue